import action from "../helpers/rest-client";

export class ErrorSubCriterion extends Error {}

class SubCriterion {
  public new(payload) {
    return action
      .Post({
        url: "/subcriterion",
        body: payload,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
  public getAll(payload) {
    if (payload?.filterBy) {
      payload.filterBy = JSON.stringify(payload?.filterBy);
    }

    if (payload?.select) {
      payload.select = JSON.stringify(payload?.select);
    }

    const queryString = new URLSearchParams(payload).toString();

    return action
      .Get({
        url: `/subcriterion?platform=CONSTANA${
          queryString ? "&" + queryString : ""
        }`,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
  public update(payload) {
    const { _id, ...rest } = payload;
    return action
      .Patch({
        url: `/subcriterion/${_id}`,
        body: rest,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
  public delete(payload) {
    const { _id, ...rest } = payload;
    return action
      .Del({
        url: `/subcriterion/${_id}`,
        body: rest,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
}

const subcriterion = new SubCriterion();
export default subcriterion;
